// TermsOfUse.jsx
import '../../input.css'
import { useTranslation } from 'react-i18next'
import Policy from './Policy'

const termsOfUsePt = (
  <div>
    <p>
      Estes Termos de Uso ("Termos") regem o acesso e a utilização da plataforma
      Benjamin e serviços relacionados ("Serviços"), oferecidos pela LEANIT101
      SERVIÇOS EM INFORMÁTICA, CNPJ 22.724.260/0001-42 ("Lean it 101", "nós"). Ao
      acessar ou utilizar os Serviços, você concorda com estes Termos.
    </p>
    <br />
    <div>
      <strong>Resumo rápido</strong>
      <ul>
        <li>Benjamin é uma plataforma de agentes com créditos e assinaturas.</li>
        <li>Assinaturas renovam automaticamente até cancelamento.</li>
        <li>Você é responsável pelos dados que envia e pelo uso do sistema.</li>
        <li>Saídas de IA podem conter erros e exigem validação humana.</li>
        <li>Aplicam-se restrições de uso e regras de propriedade intelectual.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Definições</strong>
    </div>
    <br />
    <div>
      - <strong>Benjamin</strong>: plataforma de agentes e automações da Lean it
      101.
    </div>
    <div>
      - <strong>Cliente</strong>: pessoa física ou jurídica que contrata os
      Serviços.
    </div>
    <div>
      - <strong>Usuário</strong>: pessoa autorizada pelo Cliente a acessar o
      Benjamin.
    </div>
    <div>
      - <strong>Conteúdo do Cliente</strong>: dados e materiais enviados ao
      Benjamin (textos, arquivos, integrações, instruções).
    </div>
    <div>
      - <strong>Créditos</strong>: unidades de consumo definidas nos planos.
    </div>
    <br />
    <div>
      <strong>2. Acesso e conta</strong>
    </div>
    <br />
    <div>
      Você deve manter seus dados corretos, proteger suas credenciais e garantir
      que seus usuários sigam estes Termos. Se você usa o Benjamin em nome de
      uma empresa, declara que possui autoridade para vincular essa empresa.
    </div>
    <br />
    <div>
      <strong>3. Uso aceitável</strong>
    </div>
    <br />
    <div>
      É proibido: (i) violar leis aplicáveis; (ii) fazer engenharia reversa;
      (iii) acessar áreas não autorizadas; (iv) usar o Benjamin para envio de
      spam, abuso ou conteúdo ilegal; (v) tentar burlar limites de uso ou
      créditos.
    </div>
    <br />
    <div>
      <strong>4. IA e responsabilidade</strong>
    </div>
    <br />
    <div>
      O Benjamin usa inteligência artificial e pode produzir respostas
      imprecisas. Você é responsável por revisar e validar qualquer saída antes
      de executar decisões de negócio ou operacionais.
    </div>
    <br />
    <div>
      <strong>5. Planos, créditos e pagamentos</strong>
    </div>
    <br />
    <div>
      Pagamentos são processados pela Stripe. Ao assinar, você concorda com os
      termos da Stripe. Assinaturas mensais ou anuais renovam automaticamente
      até cancelamento. Créditos não são transferíveis e expiram conforme o
      plano. Salvo exigência legal, pagamentos não são reembolsáveis.
    </div>
    <br />
    <div>
      <strong>6. Conteúdo do Cliente</strong>
    </div>
    <br />
    <div>
      O Conteúdo do Cliente permanece de sua propriedade. Você nos concede
      licença limitada para hospedar, processar e exibir esse conteúdo com o
      objetivo de prestar os Serviços. Podemos usar dados agregados e
      desidentificados para melhorar o Benjamin. Você pode solicitar a exclusão
      desses usos entrando em contato com support@leanit101.com.
    </div>
    <br />
    <div>
      <strong>7. Integrações</strong>
    </div>
    <br />
    <div>
      Integrações podem exigir credenciais e APIs de terceiros. Você é
      responsável por obter permissões necessárias e manter essas credenciais
      seguras.
    </div>
    <br />
    <div>
      <strong>8. Propriedade intelectual</strong>
    </div>
    <br />
    <div>
      O Benjamin, marcas, logos, software e conteúdos da Lean it 101 são
      protegidos por leis de propriedade intelectual. Você recebe uma licença
      limitada, não exclusiva e intransferível para uso interno, conforme o
      plano contratado.
    </div>
    <br />
    <div>
      <strong>9. Suspensão e rescisão</strong>
    </div>
    <br />
    <div>
      Podemos suspender o acesso em caso de violação destes Termos, exigência
      legal ou risco à segurança. Você pode cancelar a assinatura a qualquer
      momento; o acesso permanece até o fim do período já pago.
    </div>
    <br />
    <div>
      <strong>10. Limitação de responsabilidade</strong>
    </div>
    <br />
    <div>
      Os Serviços são fornecidos "no estado em que se encontram". Na máxima
      extensão permitida por lei, nossa responsabilidade total se limita aos
      valores pagos pelo Cliente nos 12 meses anteriores ao evento que gerou a
      responsabilidade.
    </div>
    <br />
    <div>
      <strong>11. Lei aplicável e foro</strong>
    </div>
    <br />
    <div>
      Estes Termos são regidos pela lei brasileira, com foro de Palhoça/SC,
      Brasil, salvo regras obrigatórias de proteção ao consumidor aplicáveis ao
      seu país.
    </div>
    <br />
    <div>Última atualização: 27 de dezembro de 2025</div>
  </div>
)

const termsOfUseEn = (
  <div>
    <p>
      These Terms of Use ("Terms") govern your access to and use of the
      Benjamin platform and related services ("Services") provided by LEANIT101
      SERVIÇOS EM INFORMÁTICA, CNPJ 22.724.260/0001-42 ("Lean it 101", "we"). By
      accessing or using the Services, you agree to these Terms.
    </p>
    <br />
    <div>
      <strong>Quick summary</strong>
      <ul>
        <li>Benjamin is an agent platform powered by credits and subscriptions.</li>
        <li>Subscriptions auto-renew until cancelled.</li>
        <li>You are responsible for the data you submit and how you use the system.</li>
        <li>AI output may be inaccurate and must be validated by humans.</li>
        <li>Use is subject to IP and acceptable-use restrictions.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Definitions</strong>
    </div>
    <br />
    <div>
      - <strong>Benjamin</strong>: Lean it 101’s agent and automation platform.
    </div>
    <div>
      - <strong>Customer</strong>: the individual or entity contracting the Services.
    </div>
    <div>
      - <strong>User</strong>: a person authorized by the Customer to access Benjamin.
    </div>
    <div>
      - <strong>Customer Content</strong>: data and materials submitted to Benjamin.
    </div>
    <div>
      - <strong>Credits</strong>: usage units defined by each plan.
    </div>
    <br />
    <div>
      <strong>2. Access and account</strong>
    </div>
    <br />
    <div>
      You must keep account information accurate, protect your credentials, and
      ensure your users comply with these Terms. If you use Benjamin on behalf
      of a company, you represent that you are authorized to bind that company.
    </div>
    <br />
    <div>
      <strong>3. Acceptable use</strong>
    </div>
    <br />
    <div>
      You may not: (i) violate applicable laws; (ii) reverse engineer; (iii)
      access unauthorized areas; (iv) use Benjamin for spam, abuse, or illegal
      content; (v) attempt to bypass usage or credit limits.
    </div>
    <br />
    <div>
      <strong>4. AI disclaimer</strong>
    </div>
    <br />
    <div>
      Benjamin uses artificial intelligence and may produce inaccurate output.
      You are responsible for reviewing and validating any output before acting
      on it.
    </div>
    <br />
    <div>
      <strong>5. Plans, credits, and payments</strong>
    </div>
    <br />
    <div>
      Payments are processed by Stripe. By purchasing, you agree to Stripe’s
      terms. Monthly or annual subscriptions auto-renew until cancelled.
      Credits are non-transferable and expire according to the plan. Payments
      are non-refundable except as required by law.
    </div>
    <br />
    <div>
      <strong>6. Customer Content</strong>
    </div>
    <br />
    <div>
      You retain ownership of Customer Content. You grant us a limited license
      to host, process, and display it to deliver the Services. We may use
      aggregated and de-identified data to improve Benjamin. You may request an
      opt-out by contacting support@leanit101.com.
    </div>
    <br />
    <div>
      <strong>7. Integrations</strong>
    </div>
    <br />
    <div>
      Integrations may require third-party credentials and permissions. You are
      responsible for obtaining and securing those credentials.
    </div>
    <br />
    <div>
      <strong>8. Intellectual property</strong>
    </div>
    <br />
    <div>
      Benjamin, trademarks, logos, software, and content are protected by IP
      laws. You receive a limited, non-exclusive, non-transferable license for
      internal use under your plan.
    </div>
    <br />
    <div>
      <strong>9. Suspension and termination</strong>
    </div>
    <br />
    <div>
      We may suspend access for violations, legal requirements, or security
      risk. You may cancel at any time; access remains through the end of the
      paid period.
    </div>
    <br />
    <div>
      <strong>10. Limitation of liability</strong>
    </div>
    <br />
    <div>
      The Services are provided "as is". To the maximum extent permitted by
      law, our total liability is limited to the amounts paid by the Customer
      in the 12 months prior to the event giving rise to liability.
    </div>
    <br />
    <div>
      <strong>11. Governing law</strong>
    </div>
    <br />
    <div>
      These Terms are governed by Brazilian law, with venue in Palhoça/SC,
      Brazil, except where mandatory consumer protection laws apply in your
      jurisdiction.
    </div>
    <br />
    <div>Last updated: December 27, 2025</div>
  </div>
)

const TermsOfUse = () => {
  const { i18n } = useTranslation()
  const isPt = i18n.language && i18n.language.toLowerCase().startsWith('pt')
  return (
    <div className="">
      <Policy
        name={isPt ? 'Termos de uso' : 'Terms of use'}
        text={isPt ? termsOfUsePt : termsOfUseEn}
      />
    </div>
  )
}

export default TermsOfUse
